import { SET_ENABLE_LINKIFY, SET_MEDIA_TOKEN } from './editor-config-actions';

export default function editorConfig(state = null, { type, payload }) {
  switch (type) {
    case SET_ENABLE_LINKIFY:
      return { ...state, enableLinkify: payload };
    case SET_MEDIA_TOKEN:
      return { ...state, mediaToken: payload };
    default:
      return state;
  }
}
